<template>
<w-sliding-popup ref="slidingPopup" :title="title" width="800px" @close="close()">
  <div slot="content" style="height:100%">
    <el-input type="textarea" :rows="20" v-model="resultBuffer" :readonly="true" style="height:100%"></el-input>
  </div>
</w-sliding-popup>
</template>

<script>
import { isNil, isEqual } from 'lodash';
import { getValueAfterCheckEmpty, EMPTY_TEXT } from '@/utils/string';
import AmsResultAPI from '@/api/ams/result';

const defaultFormatter = (row, column, value) => getValueAfterCheckEmpty(value);

export default {
  name: 'WExecutionResultBufferPopup',
  props: {
    selectedResult: {
      type: Object,
      default: () => null,
    },
  },
  computed: {
    title() {
      let title = EMPTY_TEXT;
      if (!isNil(this.selectedResult)) {
        title = `[${this.selectedResult.jobName} - ${this.selectedResult.nodeName}] 수행 결과`;
      }

      return title;
    },
  },
  data() {
    return {
      resultBuffer: null,
    };
  },
  methods: {
    open() {
      this.$refs.slidingPopup.visible = true;
      this.$nextTick(() => {
        this.loadData();
      });
    },
    close() {
      this.$refs.slidingPopup.visible = false;
      this.resultBuffer = null;
    },
    loadData() {
      AmsResultAPI.getResultBuffer(this.selectedResult).then((response) => {
        const result = response.data;
        if (result.success) {
          this.resultBuffer = result.data;
        }
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/work/popup/components/ExecutionResult/popup/ExecutionResultBufferPopup.vue